module.exports = __webpack_public_path__ + "static/media/addMemberGuide3_Jap.76671ef1.png";